import { Chip, Grid, Stack } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useState } from "react";
import ChurnedReasonModal from "../Modals/ChurnedReasonModal";
import dataTableData from "../data/churned";
import DataTable from "../DataTable";
import { Add, TipsAndUpdates } from "@mui/icons-material";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";

function ChurnedReasons({ superadmin_data }) {
  const { data, processing, handleRefresh, main_data } = dataTableData();
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();
  const [suggestion, setSuggestion] = useState(false);

  const handleSubmit = async (reason) => {
    const payload = {
      type: "agency",
      reason: reason.reason,
      agency_id: agency._id,
    };
    const { response } = await AppService.churned_reasons.create({
      payload,
      toaster: true,
    });
    if (response) {
      handleRefresh();
    }
  };

  return (
    <SoftBox>
      <Grid container rowSpacing={3}>
        <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
          {/* <SoftBox mr={1}>
            <TipsAndUpdates sx={{ cursor: "pointer" }} onClick={() => setSuggestion(!suggestion)} />
          </SoftBox>
        */}
          <ChurnedReasonModal handleRefresh={handleRefresh} />
        </Grid>
        <Grid
          sx={{ overflowX: "auto", marginTop: "20px", paddingBottom: "12px" }}
          className="hideScroll"
        >
          <Stack direction="row" spacing={1}>
            {superadmin_data
              ?.filter((item) => !main_data?.some((main_data) => main_data?.reason === item?.reason))?.map((reason) => (
                <Chip
                  key={reason._id}
                  label={reason?.reason}
                  icon={<Add />}
                  onClick={() => handleSubmit(reason)}
                  sx={{ cursor: "pointer" }}
                  variant="outlined"
                />
              ))}
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <DataTable table={data} canSearch />
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default ChurnedReasons;
